import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import {
    DateRange,
    patchableState,
    patchState,
    StateUpdateCommand
} from '@flyfreely-portal-ui/flyfreely';

@Injectable()
export class OperationsSearchDataService {
    private currentSearchSource = new Subject<
        StateUpdateCommand<{
            organisationId?: number;
            time?: DateRange | undefined;
        }>
    >();

    currentSearch$ = patchableState(this.currentSearchSource, {});

    constructor() {}

    ngOnDestroy() {
        this.currentSearchSource.complete();
    }

    find(time: DateRange | undefined, organisationId: number | undefined) {
        this.currentSearchSource.next(patchState({ organisationId, time }));
    }
}
